import { memo } from 'react'

import { Paper } from '@mui/material'

import { UnderDevelopment } from '@shared/layouts'

const OverviewRaw = () => {
  return (
    <Paper sx={{ flexGrow: 1 }}>
      <UnderDevelopment />
    </Paper>
  )
}

export const Overview = memo(OverviewRaw)
